<template>
  <app-layout>
   <Head title="Autoresponder"/>
    <template #header>
      <PageBackHeader
        :href="route('autoresponder.index')"
        label="Autoresponders"
        :subtitle="autoresponder.title"
      />
    </template>

    <div class="max-w-7xl mx-auto mb-6">
      <div class="w-full p-2 sm:px-6 lg:px-8">
        <div class="overflow-hidden">
              <div class="w-100">
        <div class="bg-white shadow-xl sm:rounded-lg h-[26rem] message-detail">
          <div class="grid grid-cols-12 gap-6">

            <div class="col-span-12 lg:col-span-6 p-4 sm:p-6 lg:p-5">
              <div class="flex justify-between mb-5">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight mb-2">Autoresponder Details</h2>
                <Link :href="route('autoresponder.edit', autoresponder.id)" class="text-blue-600">
                  <font-awesome-icon :icon="['far', 'pen-to-square']" class="text-xl mr-2 text-gray-500"></font-awesome-icon>
                </Link>
              </div>
              <div class="mb-5">
                <div class="text-gray-600">Name</div>
                <p>{{ autoresponder.title}}</p>
              </div>
              <div class="mb-5">
                <div class="text-gray-600">Type</div>
                <p>
                  <autoresponder-type
                    :name="'type'"
                    :data="autoresponder"
                  ></autoresponder-type>
                </p>
              </div>
              <div v-if="autoresponder.associated_keyword" class="mb-5">
                <div class="text-gray-600">Associated Keyword</div>
                <Link
                  :href="route('keywords.view', autoresponder.associated_keyword.id)"
                  class="text-blue-600"
                >{{ autoresponder.associated_keyword.keyword.toUpperCase() }}</Link>
              </div>
              <div v-if="autoresponder.trigger_word" class="mb-5">
                <div class="text-gray-600">Trigger Word</div>
                <p>{{ autoresponder.trigger_word.toUpperCase() }}</p>
              </div>
              <div class="mb-5">
                <div class="text-gray-600">Credits used Per Message</div>
                <p>{{ creditCount }}</p>
              </div>
              <div class="mb-5">
              <div v-if="autoresponder.scheduled_days.length" class="text-gray-600">
                Schedules for Days
              </div>
                <span v-for="(days, index) in autoresponder.scheduled_days">
                  {{ days }}<span v-show="index !== (autoresponder.scheduled_days.length - 1)">,</span>
                </span>
              </div>
              <div class="mb-5">
                <div v-if="autoresponder.type === 'global'" class="text-gray-600">Schedules Time</div>
                <span v-if="autoresponder.type === 'global'">{{this.parseTime(autoresponder.start_time)}} to {{parseTime(autoresponder.end_time)}}</span>
              </div>
            </div>
            <div class="col-span-12 lg:col-span-6 pt-4 sm:pt-6 lg:pt-5 pr-4 sm:pr-6 lg:pr-5">
              <div class="message-preview-wrapper">
                <div class="message-preview-wrapper-inner" ref="messagePreviewWrapperInner">
                  <div class="message-preview">
                    <div
                      v-if="this.autoresponder.type === 'keyword'"
                      class="p-3 text-white bg-blue-500 rounded-lg mb-3"
                    >
                      You have been added to the list '{{
                        this.selectedKeywordGroup ? this.selectedKeywordGroup : "LIST NAME"
                      }}'. Reply 'LEAVE' at any point to be removed from this list.
                    </div>
                    <img v-if="messageDetails.media" :src="messageDetails.media"
                                  class="block w-full rounded-lg mb-3" alt="preview of image attachment" />
                                <div v-if="messagePreview" class="p-3 text-white bg-blue-500 rounded-lg"
                                  v-html="messagePreview"></div>
                                <div  v-else-if="!messagePreview && !messageDetails.media" class="p-3 text-gray-700 bg-gray-100 rounded">
                                  Enter a message to show preview...
                                </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "../../Jetstream/Button";
import AutoresponderType from "../../components/AutoresponderTable/AutoresponderType";
// import ContactMessaged from "../../components/ContactMessaged.vue";

import axios from "axios";
import {SegmentedMessage} from "sms-segments-calculator";

export default {

  components: {
    AppLayout,
    JetButton,
    AutoresponderType
  },
  props: {
    autoresponder: Object
  },
  data() {
    return {
      segment_lengths: {
        sms_ucs: 70,
        sms_gsm: 160,
        mms_ucs: 1000,
        mms_gsm: 1600
      },
      sms_segment_credit: 1,
      mms_segment_credit: 3,
      selectedKeywordGroup: null,
    }
  },
  mounted() {
    this.updateDefaultMessage();
  },
  computed: {
     messagePreview() {
        const pattern = /{\s*([a-zA-Z]+)(\s+(default)\=[\'\"]([^\'\"\n]*)[\'\"])?\s*}/g;
        const linkPattern = /\{\s?link url="([^"]*)"(?:\s?track)?\s?\}/g;
        const fieldsMap = {
            'firstName': 'first_name',
            'lastName': 'last_name',
        };
        const matches = [...this.messageDetails.message.matchAll(new RegExp(pattern))];
        const linkMatches = [...this.messageDetails.message.matchAll(new RegExp(linkPattern))];

        var newMessage = this.messageDetails.message.replace(/\n/g, '<br />');

        matches.forEach(match => {
            const fieldKey = fieldsMap.hasOwnProperty(match[1]) ?
                fieldsMap[match[1]] : null;
            const defaultValue = match[4];

            const fieldValue = (
                this.contact &&
                fieldKey &&
                this.contact[fieldKey] &&
                this.contact[fieldKey].length > 0
             ) ? this.contact[fieldKey] : null;

            const replaceWith = fieldValue ?
                fieldValue :
                defaultValue ? defaultValue : null;

            const helpText = 'This is a variable. It will be replaced with the corresponding field for each contact. If the field is not available, it will look for a default value. If no default is found, the variable will be omitted.';

            const variableHtml = replaceWith ?
                `<span class="message-preview-variable" title="${helpText}">${replaceWith}</span>` :
                '';

            newMessage = newMessage.replace(match[0], variableHtml);
        });
         // Swap out link tags in the message with a preview of what the shortened link will actually look like
            linkMatches.forEach(match => {
              const replaceWith = "txts.pt/XXXXXXX";
              const helpText = 'This is a link placeholder. It will be replaced with a shortened link that will redirect recipients to the original link you entered.';
              const variableHtml = replaceWith ?
                `<span class="message-preview-variable" title="${helpText}">${replaceWith}</span>` :
                '';

              newMessage = newMessage.replace(match[0], variableHtml);
            });

        return newMessage;
    },
    messageSegments() {
      return new SegmentedMessage(this.autoresponder.message);
    },
    characterCount() {
      return this.autoresponder.message.length;
    },
    /*
        Estimated number of credits to be used by the message
         */
    creditCount() {
      if (this.autoresponder.media) {
        // get total estimated credit cost
        if ( this.messageSegments.encodingName === 'GSM-7' && this.characterCount ) {
          return Math.ceil(this.characterCount / this.segment_lengths.mms_gsm) * this.mms_segment_credit * 1;
        }

        if ( this.messageSegments.encodingName === 'UCS-2' && this.characterCount ) {
          return Math.ceil(this.characterCount / this.segment_lengths.mms_ucs) * this.mms_segment_credit * 1;
        }

        if ( !this.characterCount) {
          return this.mms_segment_credit;
        }
      } else {
        return this.messageSegments.segmentsCount * 1;
      }
    },
    messageDetails() {
      return this.autoresponder
    }
  },
  methods: {
    parseTime(time) {
      let [hour, min, sec] = time.split(':');
      hour = parseInt(hour, 10);
      let period = 'AM';
      if (hour >= 12) {
        period = 'PM';
        if (hour > 12) {
          hour -= 12;
        }
      } if (hour === 0) {
        hour = 12
      }
      return `${hour}:${min} ${period}`;
    },
    async updateDefaultMessage() {
      const keyword = this.autoresponder.associated_keyword;
      if (keyword) {
        let keywordGroupResponse = await axios.get(`/api/keyword/${keyword.id}/group-title`);
        this.selectedKeywordGroup = keywordGroupResponse.data
      }
    },
  },


};
</script>
<style scoped lang="scss">
@media(min-width: 1025px) {

  .message-detail,
  .message-analytics {
    height: 425px;
  }
}

.message-preview-wrapper {
  @apply mx-auto px-9 pb-4 relative bg-no-repeat bg-top max-w-xs;
//  padding-top: 105px;
  background-image: url("/images/iphone-wrapper-cropped.png");
  background-size: 100%;
//  height: 100%;
}

.message-preview-wrapper-inner {
  @apply h-full relative pt-3 pb-5 rounded-lg overflow-auto;
  min-height: 204px;
  max-height: 400px;
}

.message-preview-wrapper:before {
  @apply absolute inset-x-8 top-16 h-6 z-10;
  content: "";
  background: linear-gradient(180deg, white, transparent);
}

.message-preview-wrapper:after {
  display: none !important;
}

.message-preview {
  @apply flex flex-col items-start justify-end;
  min-height: 180px;
}

@media (min-width: theme("screens.lg")) {
  .message-preview-wrapper-inner {
    min-height: 284px;
  }

  .message-preview {
    min-height: 240px;
  }
}

.message-preview-variable {
  @apply bg-blue-700 shadow leading-loose px-2 py-1 font-black;
  cursor: help;
}

span.label {
  text-transform: capitalize;
  cursor: help;

  &.delivered {
    @apply bg-green-300;
    @apply text-green-800;
  }

  &.received {
    @apply bg-blue-300;
    @apply text-blue-800;
  }

  &.pending {
    @apply bg-yellow-300;
    @apply text-yellow-800;
  }

  &.undelivered,
  &.error,
  &.failed,
  &.attempt_rejected {
    @apply bg-red-300;
    @apply text-red-800;
  }
}
</style>
